/* cl-cart-drawer (nubelle): gaveta lateral do clone (replica do mini-cart do Focal 12 dele).
   Abre no icone do carrinho do header e ao adicionar produto (intercepta todo form /cart/add em captura).
   Renderiza de /cart.js; quantidade/remocao por /cart/change.js; frete gratis pela meta da secao;
   cupom -> /checkout?discount=CODIGO. */
(function () {
  var D = document.getElementById('ClCart');
  if (!D) return;
  var OV = document.getElementById('ClCartOverlay');
  var $ = function (s) { return D.querySelector(s); };
  var FMT = D.getAttribute('data-money') || '{{amount}}';
  var SHIP = +D.getAttribute('data-ship') || 0;
  var cart = null, code = '';
  try { code = sessionStorage.getItem('clDiscount') || ''; } catch (e) {}

  function money(c) {
    var n = (c / 100).toFixed(2), p = n.split('.');
    var dot = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'), com = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return FMT.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dot + ',' + p[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, dot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, com)
      .replace(/\{\{\s*amount\s*\}\}/, com + '.' + p[1]);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function open() {
    D.classList.add('is-open'); OV.classList.add('is-open'); D.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    D.classList.remove('is-open'); OV.classList.remove('is-open'); D.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  window.clCart = { open: function () { return refresh().then(open); }, close: close, refresh: function () { return refresh(); } };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cl-cart-close]')) { e.preventDefault(); close(); return; }
    var a = e.target.closest('a[href="/cart"], a[href$="/cart"], #cart-icon-bubble, [data-cart-icon], .header__icon--cart, [aria-controls="mini-cart"]');
    if (a && !D.contains(a)) { e.preventDefault(); e.stopPropagation(); window.clCart.open(); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && D.classList.contains('is-open')) close(); });

  /* adicionar: todo form /cart/add da pagina (buybox copiado, cards, upsell) */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1 || f.hasAttribute('data-cl-native')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fd = new FormData(f);
    // quantidade fora do form (quantity-selector do Focal usa form="...")
    if (!fd.get('quantity') && f.id) {
      var q = document.querySelector('input[name="quantity"][form="' + f.id + '"]');
      if (q) fd.set('quantity', q.value || '1');
    }
    var btn = e.submitter || f.querySelector('[type=submit]'); if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refresh(); }).then(open)
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Dieses Produkt konnte nicht hinzugefügt werden.'); })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  }, true);

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); return c; });
  }
  function bubbles(n) {
    document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count], #cart-icon-bubble .cart-count').forEach(function (b) { b.textContent = n; });
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      var s = b.querySelector('span[aria-hidden]'); if (s) s.textContent = n; b.style.display = n ? '' : 'none';
    });
  }
  var MINUS = '<svg focusable="false" width="8" height="2" viewBox="0 0 8 2"><path d="M0 1h8" stroke="currentColor" stroke-width="2" fill="none"></path></svg>';
  var PLUS = '<svg focusable="false" width="8" height="8" viewBox="0 0 8 8"><path d="M0 4h8M4 0v8" stroke="currentColor" stroke-width="2" fill="none"></path></svg>';
  function line(it, i) {
    var cmp = it.original_line_price > it.final_line_price ? it.original_line_price :
      (it.variant && it.variant.compare_at_price) ? 0 : 0;
    var unitCmp = it.compare_at_price || (it.variant && it.variant.compare_at_price) || 0;
    var was = unitCmp > it.final_price ? '<span class="cl-was">' + money(unitCmp * it.quantity) + '</span>' : (cmp ? '<span class="cl-was">' + money(cmp) + '</span>' : '');
    var v = it.variant_title && !it.product_has_only_default_variant ? '<span class="cl-md__lvar">' + esc(it.variant_title) + '</span>' : '';
    return '<div class="cl-md__line" data-line="' + (i + 1) + '">' +
      '<a class="cl-md__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img(it.image, 276)) + '" alt="" width="92" height="92" loading="lazy"></a>' +
      '<div class="cl-md__lineinfo"><a class="cl-md__ltitle" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + v +
      '<div class="cl-md__lprice"><span class="cl-now">' + money(it.final_line_price) + '</span>' + was + '</div>' +
      '<div class="cl-md__qrow"><div class="cl-md__qty"><button type="button" data-q="-1" aria-label="Menge verringern">' + MINUS + '</button>' +
      '<input type="number" min="0" step="1" inputmode="numeric" value="' + it.quantity + '" aria-label="Menge ändern">' +
      '<button type="button" data-q="1" aria-label="Menge erhöhen">' + PLUS + '</button></div>' +
      '<button type="button" class="cl-md__remove" data-remove aria-label="Entfernen">×</button></div></div></div>';
  }
  function render() {
    var n = cart.item_count;
    bubbles(n);
    $('[data-clc-title]').textContent = n ? (n === 1 ? D.getAttribute('data-one') : D.getAttribute('data-many')).replace('{n}', n) :
      $('[data-clc-title]').getAttribute('data-empty') || $('[data-clc-title]').textContent;
    $('[data-clc-empty]').hidden = n > 0;
    $('[data-clc-full]').hidden = n === 0;
    $('[data-clc-items]').innerHTML = cart.items.map(line).join('');
    $('[data-clc-sub]').textContent = money(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
    $('[data-clc-total]').textContent = money(cart.total_price);
    var left = SHIP - cart.total_price;
    $('[data-clc-msg]').textContent = left > 0 ? D.getAttribute('data-ship-left').replace('{amount}', money(left)) : D.getAttribute('data-ship-done');
    $('[data-clc-fill]').style.width = (SHIP ? Math.min(100, cart.total_price * 100 / SHIP) : 100) + '%';
    var co = $('[data-clc-checkout]');
    co.setAttribute('href', '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''));
  }
  var title = $('[data-clc-title]'); title.setAttribute('data-empty', title.textContent);
  function change(lineNo, qty) {
    var row = D.querySelector('.cl-md__line[data-line="' + lineNo + '"]'); if (row) row.classList.add('is-busy');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineNo, quantity: qty }) }).then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.items) { cart = c; render(); } else return refresh(); });
  }
  D.addEventListener('change', function (e) {
    var q = e.target.closest('.cl-md__qty input'); if (!q) return;
    change(+q.closest('.cl-md__line').getAttribute('data-line'), Math.max(0, parseInt(q.value, 10) || 0));
  });
  D.addEventListener('click', function (e) {
    var r = e.target.closest('[data-remove]');
    if (r) { e.preventDefault(); change(+r.closest('.cl-md__line').getAttribute('data-line'), 0); return; }
    var b = e.target.closest('[data-q]');
    if (b) {
      e.preventDefault();
      var row = b.closest('.cl-md__line'), inp = row.querySelector('input');
      change(+row.getAttribute('data-line'), Math.max(0, (parseInt(inp.value, 10) || 0) + (+b.getAttribute('data-q'))));
      return;
    }
    if (e.target.closest('[data-clc-apply]')) {
      e.preventDefault();
      code = ($('[data-clc-code]').value || '').trim();
      try { sessionStorage.setItem('clDiscount', code); } catch (x) {}
      var m = $('[data-clc-code-msg]');
      m.hidden = !code; m.textContent = code ? 'Gutschein "' + code + '" wird an der Kasse angewendet.' : '';
      if (cart) render();
    }
  });
  if (code) { $('[data-clc-code]').value = code; }
  refresh();
})();
